// Tu postupne pojdu volania na backend API (central-sb, loadPure)
service = {
    // HLAVNA FUNKCIA zabezpecujuca ziskanie dat a ich renderovanie pre jednotlive stranky
    loadPure(pageID, extendedID, refresh, loadAll) {
        try {
            var cache, requestUrl, parse = true;
            var isWholeMenu, auth = false;
            resolveOfferURL = function (offerURL, noCustomerID) {
                try {
                    if (profile.OddsCacheFeed) {
                        parse = false;
                        if (!noCustomerID && profile.OfferOddsCacheCustomerID.length) {
                            if (offerURL.includes("?")) {
                                return offerURL + "&CustomerID=" + profile.OfferOddsCacheCustomerID;
                            } else {
                                return offerURL + "?CustomerID=" + profile.OfferOddsCacheCustomerID;
                            }
                        }
                        return offerURL;
                    } else {
                        parse = true;
                        return offerURL;
                    }
                } catch (e) {
                    console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
                    return false;
                }
            }
            // Loading started
            modal.showLoading();
            // Nastavenie requestURL
            if (pageID && offer) {

                switch (pageID) {
                    case "popularLeaguesHome":
                        offer.pointer = offer.SeSpID = null;
                        offer.favSportID = offer.sportEventID = offer.sportID = offer.regionID = offer.leagueCupID = -1;
                        cache = service.dataCache("TopOfferLeagueCups", "LOAD");
                        // Ak je CACHE prazdna
                        if (!cache.data)
                            requestUrl = resolveOfferURL(url.offer + "TopOfferLeagueCups/Top/" + offer.topLeagues
                                + "/Site/" + offer.country
                                + "/LanguageID/" + offer.lang);
                        break;

                    case "home":
                        offer.pointer = offer.SeSpID = null;
                        offer.favSportID = offer.sportEventID = offer.sportID = offer.regionID = offer.leagueCupID = -1;
                        cache = service.dataCache("EventsOfDay", "LOAD");
                        // Ak je CACHE prazdna
                        if (!cache.data) {
                            requestUrl = resolveOfferURL(url.offer + "TopBetting/Top/" + offer.maxEventsOfDay
                                + "/Site/" + offer.country
                                + "/LanguageID/" + offer.lang
                                + "/TimeZoneID/" + offer.zone
                                + "/Date/" + offer.eventsOfDay);

                            cache.mapCallback = service.mapTopEvents;
                        }
                        break;

                    case "popularLeagues":
                        offer.pointer = offer.SeSpID = null;
                        offer.favSportID = offer.sportEventID = offer.sportID = offer.regionID = offer.leagueCupID = -1;
                        cache = service.dataCache("TopOfferLeagueCups", "LOAD");
                        // Ak je CACHE prazdna
                        if (!cache.data)
                            requestUrl = resolveOfferURL(url.offer + "TopOfferLeagueCups/Top/" + offer.topLeagues
                                + "/Site/" + offer.country
                                + "/LanguageID/" + offer.lang);
                        events.eventsCompetitionModule.goldenLeagueRender(false);
                        events.eventsCompetitionModule.jackpotGet(true);
                        break;

                    case "sportsBook":
                        offer.loadAll = false;
                        isWholeMenu = true;
                        offer.pointer = offer.SeSpID = null;
                        offer.favSportID = offer.sportEventID = offer.sportID = offer.regionID = offer.leagueCupID = offer.SeSpID = offer.SportEventID = -1;
                        if (stored.allMenu) player.playerFavoritesModule.favoriteStructure(stored.allMenu);
                        offer.sportEventID = offer.sportID = offer.regionID = offer.leagueCupID = -1;
                        events.eventsCompetitionModule.jackpotGet(!["sportsBook", "results"].includes(offer.page));
                        if (offer.nonSportOffer.includes(offer.page)) {
                            $("#sportsBook, #events").addClass("ui-disabled");
                            offer.leagueCupID = -1;
                            if (offer.page === "onlyLive" && stored.UserSettings && stored.UserSettings.Original && stored.UserSettings.Original.favoriteEvent === "1" && stored.PlayerFavorite.event.length) {
                                // V pripade LIVE, ak ma hrac ulozene oblubene zapasy, tak nacita celu LIVE ponuku
                                service.loadPure('sportsBookEvents', -1, false, true);
                            } else {
                                service.loadPure('sportsBookEvents', -1);
                            }
                        }

                        break;

                    case "sportsBookRegions":
                        offer.loadAll = false;
                        isWholeMenu = true;
                        offer.favSportID = -1;
                        if (extendedID) {
                            offer.pointer = String(extendedID);
                            if (offer.pointer.substr(0, 2) == "SP") {
                                // Sport
                                $("#offerTop").text(texts.OfferSport);
                                offer.SeSpID = offer.sportID = parseInt(offer.pointer.replace(/\D/g, ''));
                                if (isNaN(offer.sportID)) offer.sportID = -1;
                                offer.sportEventID = -1;
                                if (offer.page === "onlyLive" && stored.UserSettings && stored.UserSettings.Original && stored.UserSettings.Original.favoriteEvent === "1" && stored.PlayerFavorite.event.length) {
                                    offer.loadAll = true;
                                }
                                events.eventsCompetitionModule.goldenLeagueRender(false);
                            } else {
                                offer.sportID = -1;
                                if (extendedID == "GS1") {
                                    // GoldenLeague
                                    offer.SeSpID = offer.sportEventID = 0;
                                    pageID = "sportsBookLeagues";
                                    events.eventsCompetitionModule.goldenLeagueRender(true);
                                } else if (offer.pointer === "FA0") {
                                    // Oblubene
                                    offer.favSportID = true;
                                    offer.loadAll = true;
                                    offer.SeSpID = offer.sportEventID = offer.leagueCupID = offer.sportID = offer.top = -1;
                                    events.eventsCompetitionModule.goldenLeagueRender(false);
                                } else {
                                    // SportEvent
                                    $("#offerTop").text(texts.OfferSportEvent);
                                    offer.SeSpID = offer.sportEventID = parseInt(offer.pointer.replace(/\D/g, ''));
                                    if (isNaN(offer.sportEventID)) offer.sportEventID = -1;
                                    events.eventsCompetitionModule.goldenLeagueRender(false);
                                }
                            }
                        }
                        if (["sportsBook"].includes(offer.page)) {
                            events.eventsCompetitionModule.jackpotGet(true);
                        }
                        offer.regionID = offer.leagueCupID = -1;
                        // Nacitanie plachty
                        if (!ct.ajaxFailSBRL) {
                            if (offer.pointer === "FA0") {
                                player.playerFavoritesModule.favoriteStructure(stored.allMenu);
                                // Volanie sportov a lig samostatne
                                setTimeout(function () {
                                    player.playerFavoritesModule.resolveFavoritesCall(Object.keys(stored.PlayerFavorite.pFavorites));
                                }, 0);
                            } else {
                                setTimeout(function () {
                                    service.loadPure('sportsBookEvents', undefined, undefined, offer.loadAll);
                                }, 0);
                            }
                        }

                        break;
                    case "sportsBookLeagues":
                        offer.loadAll = false;
                        isWholeMenu = true;
                        if (extendedID) {
                            offer.pointer = String(extendedID);
                            if (offer.pointer.substr(0, 4) == "FASP") {
                                // Oblubene
                                offer.sportID = parseInt(offer.pointer.replace(/\D/g, ''));
                                offer.favSportID = offer.sportID;
                                offer.regionID = -1;
                                if (stored.PlayerFavorite.sport.includes(offer.sportID)) { // TODO: 
                                    offer.loadAll = true;
                                }
                            } else if (offer.pointer.substr(0, 4) != "SESP") {
                                // Region
                                $("#offerTop").text(texts.OfferRegion);
                                offer.regionID = parseInt(offer.pointer.replace(/\D/g, ''));
                                if (isNaN(offer.regionID)) offer.regionID = -1;
                            } else {
                                // Sport (sportEvent)
                                $("#offerTop").text(texts.OfferSport);
                                offer.SeSpID = offer.sportID = parseInt(offer.pointer.replace(/\D/g, ''));
                                offer.regionID = -1;
                            }
                        }
                        offer.leagueCupID = -1;
                        // Nacitanie plachty
                        if (!ct.ajaxFailSBRL) {
                            if (offer.pointer.substr(0, 4) == "FASP") {
                                stored.PlayerFavorite.sportLeagueCupCount = 0;
                                player.playerFavoritesModule.favoriteStructure(stored.allMenu);
                                setTimeout(function () {
                                    player.playerFavoritesModule.resolveFavoritesCall([offer.sportID]);
                                }, 0);
                            } else {
                                setTimeout(function () {
                                    service.loadPure('sportsBookEvents', undefined, undefined, offer.loadAll);
                                }, 0);
                            }
                        }

                        break;
                    case "sportsBookEventsFavorites":
                        requestUrl = resolveOfferURL(url.offer + "OfferList/SportEvent/" + offer.sportEventID
                            + "/Sport/" + offer.sportID
                            + "/Region/" + offer.regionID
                            + "/LeagueCup/" + offer.leagueCupID
                            + "/Live/" + offer.onlyLive
                            + "/Date/" + offer.date
                            + "/Zone/" + offer.zone
                            + "/Top/" + offer.top
                            + "/LanguageID/" + offer.lang);
                        break;
                    case "sportsBookEventsLotteryGames":
                    case "sportsBookEvents":
                        if (extendedID) {
                            offer.pointer = String(extendedID);
                            if (offer.pointer === "-1" && offer.leagueCupID === -1 && offer.nonSportOffer.includes(offer.page)) {
                                offer.leagueCupID = -1;
                            } else {
                                $("#offerTop").text(texts.OfferLeague);
                                offer.leagueCupID = parseInt(offer.pointer.replace(/\D/g, ''));
                                if (isNaN(offer.leagueCupID)) offer.leagueCupID = -1;
                            }
                            shared.scrollModule.scrollReload("sportsBookEventsFavorites", "clear");
                            shared.scrollModule.scrollReload(pageID, "clear");
                        } else if (offer.vgID !== offer.sportID) {
                            shared.scrollModule.scrollReload(pageID, "save");
                        }
                        if (offer.page !== "results") {
                            // Kurzova ponuka
                            if (!offer.goldenLeague) {
                                // Liga
                                if (!loadAll) {
                                    // Nacitat iba prvych x udalosti
                                    offer.top = 1;
                                    $("#showAllEvents").hide().removeClass("ui-disabled");
                                } else if (loadAll == true) {
                                    // Nacitat vsetky udalosti
                                    offer.top = -1;
                                    $("#showAllEvents").addClass("ui-disabled");
                                }
                                var offerList = "OfferList";
                                if (stored.ExtendedActualOffer && offer.regionID === 1239 && offer.provider === offer.providerNameUOF) {
                                    // Pre virtualny futbal nastavi url na "OfferListVG"
                                    offerList = "OfferListVG";
                                }
                                requestUrl = resolveOfferURL(url.offer + offerList + "/SportEvent/" + offer.sportEventID
                                    + "/Sport/" + offer.sportID
                                    + "/Region/" + offer.regionID
                                    + "/LeagueCup/" + offer.leagueCupID
                                    + "/Live/" + offer.onlyLive
                                    + "/Date/" + offer.date
                                    + "/Zone/" + offer.zone
                                    + "/Top/" + offer.top
                                    + "/LanguageID/" + offer.lang);
                            } else {
                                // GoldenLeague
                                requestUrl = resolveOfferURL(url.offer + "OfferGoldenLeagueList/LeagueCup/" + offer.leagueCupID
                                    + "/Date/" + offer.date
                                    + "/Zone/" + offer.zone
                                    + "/LanguageID/" + offer.lang);
                            }
                        } else {
                            // Vysledky
                            if (!loadAll) {
                                // Nacitat iba prvych x udalosti
                                offer.top = 1;
                                $("#showAllEvents").hide().removeClass("ui-disabled");
                            } else if (loadAll == true) {
                                // Nacitat vsetky udalosti
                                offer.top = -1;
                                $("#showAllEvents").addClass("ui-disabled");
                            }
                            requestUrl = url.results + "List/SportEvent/" + offer.sportEventID
                            + "/Sport/" + offer.sportID
                            + "/Region/" + offer.regionID
                            + "/LeagueCup/" + offer.leagueCupID
                            + "/Date/" + offer.date
                            + "/Zone/" + offer.zone
                            + "/Top/" + offer.top
                            + "/LanguageID/" + offer.lang;
                        }
                        break;
                    case "sportsBookEventDetailInline":
                    case "sportsBookEventDetail":
                    case "resultsEventDetail":
                        if (extendedID) {
                            if (offer.eventID != parseInt(extendedID)) {
                                offer.eventID = parseInt(extendedID);
                                offer.reloadEvent = false;
                                shared.scrollModule.scrollReload(pageID, "clear");
                            } else if (["sportsBookEventDetail", "resultsEventDetail"].includes(pageID)) {
                                offer.reloadEvent = true;
                                shared.scrollModule.scrollReload(pageID, "save");
                            }
                        } else {
                            shared.scrollModule.scrollReload(pageID, "save");
                            offer.reloadEvent = true;
                        }
                        if ((pageID === "resultsEventDetail" || stored.redirectTo === "results") && event?.currentTarget.id !== "openEvent") {
                                // Vysledky
                            requestUrl = url.results + "Detail/Event/" + offer.eventID
                            + "/Zone/" + offer.zone
                            + "/LanguageID/" + offer.lang;
                        } else {
                            // Kurzy
                            requestUrl = resolveOfferURL(url.offer + "OfferEventDetail/Event/" + offer.eventID
                            + "/Zone/" + offer.zone
                            + "/LanguageID/" + offer.lang);
                        }
                        break;

                    case "virtualGames":
                        offer.pointer = null;
                        offer.sportEventID = offer.regionID = offer.leagueCupID = -1;
                        offer.SeSpID = offer.sportID = offer.vgID;

                        // Z vyskladanej url pre virtualne hry ziskavame naraz Regiony aj Ligy
                        requestUrl = resolveOfferURL(url.offer + "Menu/WholeMenu/SportEvent/" + offer.sportEventID
                            + "/Sport/" + offer.sportID
                            + "/Live/" + offer.onlyLive
                            + "/Date/" + offer.date
                            + "/Zone/" + offer.zone
                            + "/LanguageID/" + offer.lang);

                        events.eventsCompetitionModule.goldenLeagueRender(false);
                        events.eventsCompetitionModule.jackpotGet(true);
                        break;

                    case "lotteryGames":
                        offer.pointer = null;
                        offer.sportEventID = offer.regionID = offer.leagueCupID = offer.onlyLive = -1;
                        offer.SeSpID = offer.sportID = offer.vgID;
                        offer.date = "TD";
        
                        // Z vyskladanej url pre virtualne hry ziskavame naraz Regiony aj Ligy
                        requestUrl = resolveOfferURL(url.offer + "Menu/WholeMenu/SportEvent/" + offer.sportEventID
                            + "/Sport/" + offer.sportID
                            + "/Live/" + offer.onlyLive
                            + "/Date/" + offer.date
                            + "/Zone/" + offer.zone
                            + "/LanguageID/" + offer.lang);

                        var queryParamterSeparator = "?";
                        if (requestUrl.includes("?")) {
                            queryParamterSeparator = "&";
                        }
                        requestUrl += queryParamterSeparator + "regionID=" + profile.Lottery.RegionID;

                        events.eventsCompetitionModule.goldenLeagueRender(false);
                        events.eventsCompetitionModule.jackpotGet(false);
                        break;

                    case "ticket":
                        requestUrl = url.ticket + "ticket/SBID_" + stored.SBID + "/refresh";
                        parse = false;
                        break;

                    case "ticketStatus":
                        if (stored.OriginalInputGUID && stored.SBID) {
                            requestUrl = url.ticket + "ticketcheck/" + stored.OriginalInputGUID + "/onsportbox/" + stored.SBID;
                        }
                        parse = false;
                        break;
                    case "ticketStatusTicketCode":
                        if (stored.TicketCode) {
                            if (stored.PlayerID && stored.PlayerID !== profile.ManualVerifiedPlayerID) {
                                requestUrl = url.ticket + "db/loadticket/" + stored.TicketCode + "?playerid=" + stored.PlayerID;
                            } else {
                                requestUrl = url.ticket + "db/loadticket/" + stored.TicketCode;
                            }
                        }
                        parse = false;
                        break;
                    case "ticketStatusHistory":
                        if (stored.OriginaIInputCode) {
                            requestUrl = url.ticket + "db/ticketedithistory/" + stored.OriginaIInputCode;
                        }
                        parse = false;
                        break;
                    case "myTickets":
                        // Nastavi skupinu mojich tiketov na detault - posledne tikety
                        if (!stored.myTicketsActiveGroup) stored.myTicketsActiveGroup = profile.MyTickets[0];
                        var requestedGroup = stored.myTicketsActiveGroup;
                        var filtered = "/playertickets/";
                        if (stored.myTicketsActiveGroup === "Win") {
                            // V pripade vyhernych tiketov zobrazuje len vyherne neexspirovane tikety - prida suffix. Volanie: Win_Not_Forfeited
                            requestedGroup = stored.myTicketsActiveGroup + "_Not_Forfeited";
                        } else if (stored.myTicketsActiveGroup === "Unpaid") {
                            // V pripade nevyplatenych tiketov vyziada vsetky tikety
                            filtered = "/playerticketsfiltered/";
                            requestedGroup = stored.myTicketsActiveGroup + "/datefrom/all/dateto/all/pagenr/all/pagesize/all";
                        }
                        cache = service.dataCache("MyTickets", "LOAD");
                        if (!cache.data || (cache.data.activeGroup !== stored.myTicketsActiveGroup)) {
                            delete cache.data;
                            delete cache.MyTickets;

                            requestUrl = url.ticket
                                + "ticket/SBID_" + stored.SBID
                                + "/platform/" + offer.platform
                                + filtered + requestedGroup;
                            parse = false;
                        }
                        break;

                    case "playerBonuses":
                        if (stored.PlayerID && (stored.PlayerID !== profile.ManualVerifiedPlayerID) && stored.Token) {
                            requestUrl = url.centralSBAuth + "/bonus-list?forPlatform=" + offer.platform + "&languageId=" + offer.bonusesLang + "&isForMarketingSite=false";
                            auth = true;
                            parse = false;
                        }
                        break;
                    default:
                        requestUrl = url.base + "data/" + pageID + ".json";
                        parse = false;
                        break;
                }
                if (isWholeMenu) {
                    if (offer.page != "results" && stored.redirectTo != "results") {
                        // Zobrazenie goldenLeague pre country je riadene sluzbou, jej blokovanie je mozne per SB
                        requestUrl = resolveOfferURL(url.offer + "Menu/WholeMenu/SportEvent/-1/Sport/-1"
                            + "/Live/" + offer.onlyLive
                            + "/Date/" + offer.date
                            + "/Zone/" + offer.zone
                            + "/LanguageID/" + offer.lang
                            + "?isGoldenLeagueEnabled=" + (profile.GoldenLeagueBlocked? "-1": "1"));
                        if (profile.GoldenLeagueBlocked) {
                            events.eventsCompetitionModule.goldenLeagueRender(false);
                        }

                        cache = new Object({
                            key: "wholeMenu"
                        });

                    } else {
                        requestUrl = url.results + "Menu/WholeMenu/SportEvent/-1/Sport/-1"
                            + "/Date/" + offer.date
                            + "/Zone/" + offer.zone
                            + "/LanguageID/" + offer.lang;
                    }
                }

            } else {
                // Niektory z klucovych parametrov je prazdny (pageID, zone, lang)
                main.createLog(1, "StartInitFailed", "LOCK SB # APP RESTART");
                clearTimeout(rfs.session);
                setTimeout(function () {
                    window.location = url.base;
                }, sets.heartBeat);
            }

            // Ziskanie url na pripadne overenie jej platnosti
            if (!refresh)
                setTimeout(function () {
                    url.location = window.location.hash;
                }, 0);

            if (cache && cache.data) {
                // Nacitanie dat z lokalnej CACHE
                main.buildPage(pageID, cache.data, refresh);

            } else if (requestUrl) {
                // Nacitanie dat zo servera - Asynchronne AJAX datove volanie
                try {
                    // JSONP
                    modifyRequestUrl: if (parse) {
                        // profile.OddsCacheFeed = true ak si pýtam kurzy z novej ofery. 
                        // Results idú vždy na statú oferu = JSONP = callback
                        if (profile.OddsCacheFeed && event?.currentTarget.id === "openEvent") break modifyRequestUrl;
                        if (profile.OddsCacheFeed && !(offer.page === "results" || stored.redirectTo === "results")) break modifyRequestUrl;

                        if (requestUrl.includes("?")) {
                            // Ak requestURL obsahuje url parameter/parametre, potom callback je dalsi parameter v poradi
                            requestUrl += "&callback=?";
                        } else {
                            requestUrl += "?callback=?";
                        }
                    }
                    // Loading JSON data
                    var requestUrl, requestTime = new Date().getTime() + stored.time;
                    $.ajax({
                        type: "GET",
                        url: requestUrl,
                        dataType: "json",
                        async: true,
                        beforeSend: function(xhr) {
                            if (auth) {
                                xhr.setRequestHeader("Authorization", "Bearer " + stored.Token);
                            }
                        }
                    })
                        .done(function(data, statusText, jqXHR) {

                            // Odpoved volania je v poriadku
                            if (!data && profile.OddsCacheFeed) {
                                // Prazdna 200 odpoved
                                data = service.handleLoadPureData(data, pageID);
                            }
                            if (data) {
                                if (!data.ErrorType) {

                                    // PARSE string to JSON
                                    if (parse && (typeof data == "string")) {
                                        data = $.parseJSON(data);
                                        // Zaloguje pripadny vnoreny ErrorType
                                        if (data.ErrorType) main.createLog(2, "DataError", pageID + ".json # DATA: " + JSON.stringify(data));
                                        if (profile.ConsoleLog || profile.ConsoleLog$.LoadPure) {
                                            if (requestTime) jqXHR.requestTimeUTC = new Date(requestTime);
                                            console.log(">>> LoadPure"
                                                + " | pageID: " + pageID
                                                + " | extendedID: " + extendedID
                                                + " | refresh: " + refresh
                                                + " | loadAll: " + loadAll
                                                + " | jqXHR: " + JSON.stringify(jqXHR)
                                            );
                                            console.log(data);
                                        }
                                    }

                                    // SAVE JSON to CACHE
                                    if (cache && cache.key && !data.ErrorType) service.dataCache(cache.key, "SAVE", data, cache.mapCallback);

                                    // LOAD (full data)
                                    main.buildPage(pageID, data, refresh);

                                    ct.ajaxFail = sets.ajaxFail;
                                    ct.ajaxFailSBRL = false;

                                } else {
                                    // ErrorType: 'DB_ERROR', ErrorMessage: 'Coul'd not find...'
                                    service.loadPureFailed(pageID, extendedID, refresh, 200, data.ErrorType);
                                }

                            } else {
                                if (pageID == "ticket") {
                                    // Opakovany pokus ziskania dat z tiket sluzby
                                    ticket.ticketWsRetrieve(true);
                                } else {
                                    // Spracuje ostatne vynimky po neuspesnom pokuse o ziskanie dat
                                    service.loadPureFailed(pageID, extendedID, refresh, 200, false);
                                }
                            }

                        })
                        // Vynimky po neuspesnom pokuse o ziskanie dat
                        .fail(function(jqXHR) {
                            jqXHR.requestUrl = requestUrl;
                            if (requestTime) jqXHR.requestTimeUTC = new Date(requestTime);
                            service.loadPureFailed(pageID, extendedID, refresh, jqXHR, false);
                        });
                } catch (e) {
                    console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
                    main.createLog(2, "LoadPureError", "ERROR: " + e.type);
                    modal.showErrObj(1, 5, {err1: texts.ConnectionErr, errType: "ConnectionErr"});
                    service.loadPureUnlockBtn(refresh);
                    modal.hideLoading();
                }
            } else {
                modal.showErrObj(1, 5, {err1: texts.ConnectionErr, errType: "ConnectionErr"});
                main.createLog(2, "LoadPureError", "URL missing");
                service.loadPureUnlockBtn(refresh);
                modal.hideLoading();
            }
            // Zrusenie odpoctu LIVE zapasov
            service.liveCountDownClear();
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            main.createLog(2, "LoadPureError", "RequestURL: " + requestUrl + " # ERROR: " + e);
            modal.showErrObj(1, 5, {err1: texts.ConnectionErr, errType: "ConnectionErr"});
            service.loadPureUnlockBtn(refresh);
            modal.hideLoading();
            // Zrusenie odpoctu LIVE zapasov
            service.liveCountDownClear();
        }
    },

    // Funkcia na spracovanie vynimky po neuspesnom pokuse o ziskanie dat
    loadPureFailed(pageID, extendedID, refresh, jqXHR, dbError) {
        try {
            if (profile.ConsoleLog || profile.ConsoleLog$.LoadPure) console.log("!!! LoadPureFailed"
                + " | pageID: " + pageID
                + " | extendedID: " + extendedID
                + " | refresh: " + refresh
                + " | jqXHR: " + jqXHR
                + " | dbError: " + dbError
            );

            // Jedna sa o ajax fail pri starte SB 
            if (typeof stored.lockedSB == "undefined") {
                // Zastavi opakovanie obnovy stranky pocas uzivatelskej neaktivity
                main.startPageRefresh();
                // Nastavenie poctu pokusov
                ct.ajaxFail = sets.ajaxFail;
                stored.lockedSB = false;
            }

            // SB nieje uzamknuty, alebo sa jedna o start SB
            if (ct.ajaxFail && !stored.lockedSB) {
                ct.ajaxFail--;

                // Najprv sa pokusi o opetovne nacitanie, potom vypise error
                // 200 - prazdne data
                // 404 (40x) - lokalna chyba spojenia
                // 503 - server nedostupny (odpojeny balancerom)
                main.createLog(2, "DataError", "attempt " + (sets.ajaxFail - ct.ajaxFail + 1) + "/" + (sets.ajaxFail + 1) + " -> " + pageID + ".json # AJAX FAILED: " + JSON.stringify(jqXHR));

                // sportsBookRegions a sportsBookLeagues nezavola vnoreny service.loadPure('sportsBookEvents')
                if (pageID == "sportsBookRegions" || pageID == "sportsBookLeagues") {
                    ct.ajaxFailSBRL = true;
                }

                if (pageID === "sportsBookEventsFavorites") {
                    // V pripade oblubenych (vyskladavanie sportov/lig) sa nepokusa o opatovne nacitanie obsahu, miesto toho vykresli uspesne dotiahnute zapasy
                    stored.PlayerFavorite.sportLeagueCupCount--;
                    if (stored.PlayerFavorite.sportLeagueCupCount === 0) {
                        main.buildPage("sportsBookEventsFavorites", false, false);
                    }
                } else {
                    // Novy pokus na nacitanie obsahu
                    setTimeout(function () {
                        service.loadPure(pageID, extendedID, refresh);
                    }, 200);
                }

            } else {

                ct.ajaxFail = 0;            // pocet dalsich pokusov pri AJAX error
                ct.ajaxFailSBRL = false;    // pri dalsiom neuspesnom pokuse znova zavola sportsBookEvents
                modal.hideLoading();

                if (!stored.lockedSB && pageID != "ticketStatus") {
                    $("#empty").show();
                }

                // Pre niektore stavy dochadza k zablokovaniu SB
                service.ajaxFailed(jqXHR, dbError.status, pageID);

                switch (pageID) {
                    case "home":
                        break;
                    case "popularLeagues":
                        break;
                    case "sportsBook":
                        break;
                    case "sportsBookRegions":
                        break;
                    case "sportsBookLeagues":
                        break;
                    case "sportsBookEventsLotteryGames":
                    case "sportsBookEvents":
                        stored.allEvents = null;
                        break;
                    case "sportsBookEventDetail":
                    case "resultsEventDetail":
                        main.closeDialog();
                        break;
                    case "ticket":
                        ticket.ticketWsRetrieve(true);
                        break;
                    case "ticketStatus":
                    case "ticketStatusTicketCode":
                    case "playerBonuses":
                        main.closeDialog();
                        break;
                }

                return true;
            }

        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            main.startApp(1)
            return false;
        }
    },

    // Funkcia na odomknutie buttonov pre loadPure
    loadPureUnlockBtn(refresh) {
        if (refresh) {
            $("#tableTop .rfs-ico").removeClass("rfsX-ico").parents("a").removeClass("lock-btn");
            if (event) $("#eventTop .rfs-ico").removeClass("rfsX-ico").parents("a").removeClass("lock-btn");
        }
        $("#footer").removeClass("lock-btn");
    },

    // Funkcia sluzi na odchytenie a zmenu formatu dat z funkcie loadPure
    handleLoadPureData(data, pageID) {
        try {
            if (data == null) {
                switch (pageID) {
                    // Zmeni format dat z odds-cache offer na zaklade pageID
                    case "home":
                    case "popularLeaguesHome":
                    case "sportsBookEventsLotteryGames":
                    case "sportsBookEvents":
                    case "virtualGames":
                    case "sportsBookEventDetail":
                    case "resultsEventDetail":
                        data = {};
                        break;
                    default:
                        return data;
                        break;
                }
            }
            return data;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            main.createLog(2, "handleLoadPureDataError", " # DATA: " + data + " # PAGEID: " + pageID + " # ERROR: " + e);
            modal.showErrObj(1, 5, {err1: texts.ConnectionErr, errType: "ConnectionErr"});
            return data;
        }
    },

    // Funkcia na kontrolu CACHE
    dataCache(key, operation, data, mapCallback) {
        if (key) {
            switch (operation) {

                // Ulozenie dat do cache
                case "SAVE":
                    // && data.length
                    if (data) {
                        if (mapCallback && typeof mapCallback === "function") {
                            mapCallback(data);
                        }
                        cache[key] = new Object();
                        cache[key].data = data;
                        cache[key].timeStamp = new Date().getTime();
                    } else {
                        return cache[key];
                    }
                    break;

                // Nacitanie z cache vratane kontroly validity
                case "LOAD":
                    if (cache[key] && cache[key].data && (cache[key].timeStamp + offer.cacheValidity) > new Date().getTime()) {
                        return cache[key];
                    } else {
                        // Vymazanie expirovanej CACHE
                        cache[key] = new Object();
                        cache[key].data = false;
                        cache[key].key = key;
                        return cache[key];
                    }
                    break;

                // Kontrola validity
                case "CHECK":
                    if (cache[key] && (cache[key].timeStamp - new Date().getTime()) < offer.cacheValidity) {
                        return true;
                    } else {
                        // Vymazanie expirovanej CACHE
                        delete cache[key];
                        return false;
                    }
                    break;

                default:
                    return false;
                    break;
            }
        } else {
            return false;
        }
    },

    // Strata spojenia serverom alebo DB
    ajaxFailed(jqXHR, dbError, pageID) {
        try {

            // Zavola na nativeApp zamknutie SB a definuje dovod zamknutia
            if (jqXHR && !jqXHR.status || jqXHR.status != stored.jqXHR) {
                stored.jqXHR = jqXHR.status;
                switch (jqXHR.status) {

                    // LOCK SB - DB ERROR
                    case 200:
                        if (dbError) {
                            main.lockApp(-1, texts.ConnectionErr + " DATABASE");
                            main.createLog(1, "LostConnectionError_DB", "LOCK SB # " + pageID + ".json # DB ERROR: " + dbError + " # AJAX : " + JSON.stringify(jqXHR));
                        }
                        break;

                    // LOCK SB - SSL ERROR (ERR_BAD_SSL_CLIENT_AUTH_CERT)
                    case 403:
                        main.lockApp(-1, texts.ConnectionErr + " SSL ERROR");
                        main.createLog(1, "LostConnectionError_SSL", "LOCK SB # " + pageID + ".json # AJAX FAILED: " + JSON.stringify(jqXHR));
                        break;

                    // LOCK SB - ADMIN LOCK
                    case 450:
                        main.lockApp(-1, "ADMIN LOCK");
                        main.createLog(1, "SportBox_Paused", "LOCK SB # ADMIN LOCK: " + status);
                        break;

                    // LOCK SB - SERVER ERROR (HTTP_SERVICE_UNAVAILABLE)
                    case 503:
                        main.lockApp(-1, texts.ConnectionErr + " SERVER");
                        main.createLog(1, "LostConnectionError_Server", "LOCK SB # " + pageID + ".json # AJAX FAILED: " + JSON.stringify(jqXHR));
                        break;

                    // HOME page or LOCK SB for Home page - case 0 (lost connection) or 400 (bad request), 404 (not found), 408 (netowrk timetout), 504 (server timeout)
                    default:
                        if (pageID == "home") {
                            main.lockApp(-1, texts.ConnectionErr + " DISCONNECTED ");
                            main.createLog(1, "LostConnectionError", "LOCK SB # " + pageID + ".json # AJAX FAILED: " + JSON.stringify(jqXHR) + main.connectionParamsString());
                        } else {
                            main.createLog(2, "DataConnectionError", pageID + ".json # AJAX FAILED: " + JSON.stringify(jqXHR) + main.connectionParamsString());
                            main.setPage(1);
                        }
                        break;
                }
            }

            try {
                if (!stored.lockedSB) {

                    // Zastavi vsetky refresh procesy a zatvori vsetky okna
                    clearTimeout(rfs.watcher);
                    main.stopAllRfs();

                    // Ak bol tiket na schvalovani alebo prebiehal jeho prijem tak zavola STORNO
                    if (stored.GUID || stored.ticket) {

                        // Zrusi ticket.submitTicket()
                        xhr.abort();

                        // Ak uz ma tiket vytvoreny
                        if (stored.ticket) {
                            var errLog = "GUID: " + ticket.anonymGuid(stored.ticket.SportboxTicketGUID)
                                + " # BET: " + stored.ticket.OverallBet
                                + " # FEE: " + stored.ticket.OverallFee
                                + " # RATE: " + stored.ticket.OverallRate
                                + " # WIN: " + stored.ticket.OverallPotWin
                                + " # WINFISCAL: " + stored.ticket.FiscalOverallPotWin
                                + " # CREATED: " + stored.ticket.PlaceBetDate;
                            if (!rfs.approve) {
                                // Standartny tiket
                                ticket.ticketFailed("TicketSubmit_ConnectionErr", errLog);
                            } else {
                                // Tiket na schvalovani
                                ticket.ticketFailed("TicketSubmit_ConnectionErr_OnApprove", errLog);
                            }
                        } else {
                            ticket.ticketCheck("reset");
                        }
                        stored.GUID = "onApprove";
                        main.unlockSbmButtons(true);
                    }

                    service.loadPureUnlockBtn(true);
                    modal.hideLoading();

                    // Vratenie penazi
                    player.moneyBack();
                }
            } catch (e) {
                console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
                player.moneyBack();
                main.startApp(1);
            }

            // Kontrola spojenia na server / DB
            service.checkConnection();
            return true;

        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            player.moneyBack();
            main.startApp(1);
            return false;
        }
    },

    // Funkcia sluzi na mapovanie zapasov dna pred tym nez sa data ulozia do cache
    mapTopEvents(data) {
        if (data && !data.ErrorType && data.TopEvents && data.TopEvents.length) {
            // Pozadovana hlavicka pre stlpce oddov tipName
            if (profile.FlatCSS && profile.Resolution === "1920x1080") {
                data.tipNames = ["1", "X", "2"];
            } else {
                data.tipNames = ["1", "X", "2", "1X", "12", "X2"];
            }
            data.TopEvents.map(function(event) {
                if (!event.odds) event.odds = [];

                // Rozdeli nazov zapasu na samostatne teamy
                var teamNames = event.EventName.split(' vs. ');
                event.team1 = teamNames[0];
                event.team2 = teamNames[1];

                // Rozdeli termin zaciatku zapasu na datum a cas
                event.date = event.EventDate.substr(8, 2) + "." + event.EventDate.substr(5, 2) + "." + event.EventDate.substr(0, 4);
                event.time = event.EventDate.substr(11, 5);

                data.tipNames.forEach(function(tipName) {
                    if (event["ID_" + tipName]) {
                        var localizedTip1, localizedTip2, tipTeamName;

                        if (profile.TipsFormat == "team" || profile.TipsFormat == "teamX") {
                            localizedTip1 = event.team1;
                            localizedTip2 = event.team2;
                        } else {
                            localizedTip1 = texts["EventTip-1"];
                            localizedTip2 = texts["EventTip-2"];
                        }
                        if (tipName) {
                            if (!profile.TipsFormat) {
                                tipTeamName = tipName;
                            } else {
                                switch (tipName) {
                                    case "1":
                                        tipTeamName = localizedTip1;
                                        break;
                                    case "X":
                                        tipTeamName = texts["EventTip-X"];
                                        break;
                                    case "2":
                                        tipTeamName = localizedTip2;
                                        break;
                                    case "1X":
                                        if (profile.TipsFormat === "teamX") {
                                            tipTeamName = "1X";
                                        } else {
                                            tipTeamName = localizedTip1 + " " + texts["EventTip-OR"] + " " + texts["EventTip-X"];
                                        }
                                        break;
                                    case "X2":
                                        if (profile.TipsFormat === "teamX") {
                                            tipTeamName = "X2";
                                        } else {
                                            tipTeamName = texts["EventTip-X"] + " " + texts["EventTip-OR"] + " " + localizedTip2;
                                        }
                                        break;
                                    case "12":
                                        if (profile.TipsFormat === "teamX") {
                                            tipTeamName = "12";
                                        } else {
                                            tipTeamName = localizedTip1 + " " + texts["EventTip-OR"] + " " + localizedTip2;
                                        }
                                        break;
                                    default:
                                        return tipTeamName = tipName;
                                        break;
                                }
                            }
                        }

                        event.odds[tipName] = {
                            tipName: tipName,
                            oddID: event['ID_' + tipName],
                            oddRate: event['Rate_' + tipName].toFixed(2),
                            tipTeamName: tipTeamName,
                            isTopTip: (tipName === event.TopTip)? true: false
                        }

                        if (tipName === event.TopTip) {
                            event.topTipName = tipTeamName;
                            event.topTipID = event['ID_' + tipName];
                        }
                    } else {
                        // Pre prechadzany stlpec neexistuje odd v zapase
                        event.odds[tipName] = {
                            tipName: tipName,
                            oddID: 0,
                            oddRate: '-',
                            isTopTip: false,
                            tipTeamName: false
                        };
                    }
                });
            });
        }
    },

    // Kontrola obnovenia spojenia
    checkConnection() {
        try {
            if (!ct.reconnecting) {
                ct.reconnecting = stored.lockedSB = true;
                clearInterval(rfs.reconnecting);
                rfs.reconnecting = setInterval(function () {

                    // Kontroluje danu stranku
                    cache = {};
                    service.loadPure(profile.checkPage);

                }, offer.checkConnection);

                return true;
            }

            return false;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            main.startApp(1);
            return false;
        }
    },

    // Funkcia na zrusenie odpocitavania live zapasu pred jeho zaciatkom
    liveCountDownClear() {
        Object.keys(rfs.LiveListCountDown).forEach(function(liveCountDownKey) {
            clearTimeout(rfs.LiveListCountDown[liveCountDownKey]);
        });
        rfs.LiveListCountDown = new Object();
    }
};
